import { removeKnownTrackingParameters } from '../utils/urlTracking'
import type { Note, UrlEntity } from '../domain/note'
import { isPublicLinkPreviewTarget } from '../utils/linkPreviewPolicy'

export function linkMetadataUrlKey(url: UrlEntity): string {
  return removeKnownTrackingParameters(url.canonicalUrl ?? url.originalUrl, true)
}

/** One canonical URL has one cache result, so it must have one in-flight request. */
export function collectLinkMetadataCandidates(
  notes: readonly Pick<Note, 'urls'>[],
  activeKeys: ReadonlySet<string>,
  needsRefresh: (url: UrlEntity) => boolean,
): UrlEntity[] {
  const candidatesByUrl = new Map<string, UrlEntity>()
  for (const note of notes) {
    for (const url of note.urls) {
      const key = linkMetadataUrlKey(url)
      if (isPublicLinkPreviewTarget(key) && needsRefresh(url) && !activeKeys.has(key) && !candidatesByUrl.has(key)) {
        candidatesByUrl.set(key, url)
      }
    }
  }
  return [...candidatesByUrl.values()]
}
